<div class="BagsRedemptionModal">
  <div class="BagsRedemptionModal-close">
    <img alt="" src="../../../../assets/images/close.svg" (click)="onClose()" />
  </div>
  <div class="BagsRedemptionModal-container text-center">
    <img
      alt=""
      class="BagsRedemptionModal-image"
      src="../../../../assets/images/suitcasePresent.svg"
    />

    <p class="fs-20px lh-34px fw-regular mb-1">{{ 'modalbagsredemption.titleBef' | translate }}</p>
    <p
      [innerHTML]="'modalbagsredemption.title' | translate"
      class="fs-36px lh-52px fw-medium-x"
    ></p>
    <p class="fs-20px lh-34px fw-regular mb-1">
      {{ 'modalbagsredemption.subtitleNxt' | translate }}
    </p>

    <div
      *ngIf="
        passenger.typeCobrand == 'cobrand' ||
        passenger.typeTier == 'tier' ||
        passenger.typeTier == 'corporate' ||
        (redemptionBenefitType === 'carryOn' && passenger.typeCobrandCarryOn === 'cobrand')
      "
      class="Box-befefit"
    >
      <fieldset class="radio-cards" role="radiogroup" aria-label="Selecciona un método">
        <!-- Opción: por nivel (tier) -->
        <ng-container *ngIf="passenger?.typeTier === 'tier'">
          <input
            class="radio-cards__input"
            type="radio"
            id="benefit-tier"
            name="benefitMethod"
            [value]="'tier'"
            [(ngModel)]="selectedMethod"
          />
          <label class="radio-cards__card" for="benefit-tier">
            <div class="radio-cards__bullet" aria-hidden="true"></div>
            <div class="radio-cards__content">
              <p class="txt-radiob fw-regular mb-1">
                {{ 'modalbagsredemption.nivel' | translate }}
              </p>
              <span class="one-line">
                <b>{{ 'modalbagsredemption.titleCardOne' | translate }}</b>
                <span
                  *ngIf="passenger?.benefits?.tier"
                  [ngClass]="['passenger-benefit', 'passenger-benefit--' + classTier]"
                >
                  {{ passenger?.benefits?.tier }}
                </span>
              </span>
              <div class="poss-img">
                <img class="Sz-img" alt="Rewards" src="./assets/images/AeroméxicoRewards.svg" />
              </div>
            </div>
          </label>
        </ng-container>
        <div class="divi-card"></div>
        <!-- Opción: por tarjeta (cobrand) -->
        <ng-container *ngIf="passenger?.typeCobrand === 'cobrand' || (redemptionBenefitType === 'carryOn' && passenger?.typeCobrandCarryOn === 'cobrand')">
          <input
            class="radio-cards__input"
            type="radio"
            id="benefit-cobrand"
            name="benefitMethod"
            [value]="'cobrand'"
            [(ngModel)]="selectedMethod"
          />
          <label class="radio-cards__card" for="benefit-cobrand">
            <div class="radio-cards__bullet" aria-hidden="true"></div>
            <div class="radio-cards__content">
              <p class="txt-radiob fw-regular mb-1">
                {{ 'modalbagsredemption.card' | translate }}
              </p>
              <p>
                <b>{{ cobrandLabel }}</b>
              </p>
              <div class="poss-img">
                <img class="Sz-img" alt="Cobrand" [src]="cobrandLogo" />
              </div>
            </div>
          </label>
        </ng-container>
        <ng-container *ngIf="passenger?.typeCorporate === 'corporate'">
          <input
            class="radio-cards__input"
            type="radio"
            id="benefit-corporate"
            name="benefitMethod"
            [value]="'corporate'"
            [(ngModel)]="selectedMethod"
          />
          <label class="radio-cards__card" for="benefit-corporate">
            <div class="radio-cards__bullet" aria-hidden="true"></div>
            <div class="radio-cards__content">
              <p class="txt-radiob fw-regular mb-1">
                {{ 'modalbagsredemption.card' | translate }}
              </p>
              <p>
                <b>{{ 'modalbagsredemption.titleCardTwo' | translate }}</b>
              </p>
              <div class="poss-img">
                <img class="Sz-img" alt="Rewards" src="./assets/images/AeroméxicoRewards.svg" />
              </div>
            </div>
          </label>
        </ng-container>
      </fieldset>
    </div>

    <div class="Btnsmodal gapline">
      <button class="BagsRedemptionModal-btnBenefit2" (click)="onClose()">
        {{ 'modalbagsredemption.noAccept' | translate }}</button
      >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <button
        class="BagsRedemptionModal-btnBenefit"
        (click)="onRedeem()"
        [disabled]="selectedMethod == null"
      >
        {{ 'modalbagsredemption.Accept' | translate }}
        <div class="loading-component" *ngIf="showLoading"></div>
      </button>
    </div>
  </div>
</div>
